import { Button } from "@dropbox/dig-components/buttons";
import { Text, Title } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { DigTooltip } from "@mirage/shared/util/DigTooltip";
import i18n from "@mirage/translations";
import React from "react";
import styles from "./AskQueryTooltip.module.css";
type AskQueryTooltipProps = {
  triggerRef: React.RefObject<HTMLElement>;
  placement?: "left" | "right" | "top" | "bottom";
  onDismiss?: () => void;
};

export const AskQueryTooltip: React.FC<AskQueryTooltipProps> = ({
  triggerRef,
  placement = "left",
  onDismiss,
}) => {
  return (
    <Box
      onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
      }}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
      }}
      onMouseUp={(e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
      }}
    >
      <DigTooltip.Control
        variant="rich"
        triggerRef={triggerRef}
        placement={placement}
        open={true}
        offsetDistance={10}
      >
        <Box className={styles.titleWrapper}>
          <Title size={"medium"} className={styles.title}>
            {i18n.t("omnibox_ask_query_tooltip_title")}
          </Title>
        </Box>
        <Box className={styles.textWrapper}>
          <Text size={"medium"}>
            {i18n.t("omnibox_ask_query_tooltip_text")}
          </Text>
        </Box>
        <Box className={styles.buttonWrapper}>
          <Button
            variant="outline"
            size="standard"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              e.stopPropagation();
              onDismiss?.();
            }}
          >
            {i18n.t("omnibox_ask_query_tooltip_button_text")}
          </Button>
        </Box>
      </DigTooltip.Control>
    </Box>
  );
};
